import { render, staticRenderFns } from "./OnboardingPDF.vue?vue&type=template&id=faef41b2&"
import script from "./OnboardingPDF.vue?vue&type=script&lang=js&"
export * from "./OnboardingPDF.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPDF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports